import { useMemo, useState } from "react";
import { styled } from "styled-components";
import { useAppState } from "../../AppContext";
import { useSearchParams } from "../../hooks/useSearchParams";
import IsDesktop from "../../shared/components/IsDeskop";
import IsMobile from "../../shared/components/IsMobile";
import { WordpressAttribution } from "../../types";

export const Attribution = () => {
  const searchParams = useSearchParams<"hide-menu">();
  const { state } = useAppState();
  const [showPopup, setShowPopup] = useState(false);

  const attributionEntries = useMemo(
    () =>
      state.attribution
        .map((attr, i) => <AttributionEntry key={attr.url} attr={attr} first={!i} />),
    [state.attribution]
  );

  const hideMenu = useMemo(() => {
    return searchParams["hide-menu"] !== undefined;
  }, [searchParams]);

  if (!hideMenu) {
    return null;
  }

  return (
    <>
      <IsDesktop>
        <AttributionContainer>{attributionEntries}</AttributionContainer>
      </IsDesktop>
      <IsMobile>
        <MobileAttributionIcon onClick={() => setShowPopup(true)}>©</MobileAttributionIcon>
        {showPopup && (
          <>
            <PopupBackdrop onClick={() => setShowPopup(false)} />
            <MobileAttributionPopup>{attributionEntries}</MobileAttributionPopup>
          </>
        )}
      </IsMobile>
    </>
  );
};

const AttributionEntry = ({
  attr,
  first,
}: {
  attr: WordpressAttribution;
  first: boolean;
}) => (
  <span>
    {!first && " | "}
    <a href={attr.url} target="_blank" rel="noreferrer">
      {attr.label}
    </a>
  </span>
);

const AttributionContainer = styled.div`
  position: absolute;
  height: 16px;
  bottom: 0;
  right: 0;
  font-size: 12px;
  background: rgba(255, 255, 255, 0.5);
  color: rgb(61, 58, 88);
  padding: 0 4px;
  z-index: 50;

  a {
    color: rgb(61, 58, 88);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const MobileAttributionIcon = styled.div`
  position: absolute;
  bottom: 8px;
  right: 8px;
  z-index: 50;
  font-size: 16px;
  width: 20px;
  height: 20px;
  color: rgb(61, 58, 88);
  background: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MobileAttributionPopup = styled.div`
  position: fixed;
  bottom: 36px;
  right: 8px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: var(--border-radius-10);
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.15);
  padding: var(--space-20);
  z-index: 102;
  font-size: 14px;

  a {
    color: rgb(61, 58, 88);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const PopupBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.1);
  z-index: 101;
`;
